<template>
  <section class="apply-invoice">
    <table class="table">
      <tr>
        <th>ご請求先</th>
        <td>
          <div class="row">
            <div class="col-md-6">
              <select
                ref="SEIKYU_SAKI_KBN"
                class="form-control form-input"
                v-model="form.SEIKYU_SAKI_KBN"
              >
                <option :value="false">上記企業情報と同じ</option>
                <option :value="true">上記企業情報と異なる</option>
              </select>
            </div>
          </div>
        </td>
      </tr>
    </table>

    <table v-if="form.SEIKYU_SAKI_KBN" class="table">
      <tr>
        <th>
          正式企業名（請求先）
          <br v-if="isTablet" />
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="SKS_KAISYA"
            v-slot="{ errors }"
            rules="required|max:30|char"
          >
            <b-form-input
              v-model="form.SKS_KAISYA"
              ref="SKS_KAISYA"
              class="col-md-6"
              maxlength="30"
              :state="errors.length ? false : null"
              placeholder="株式会社ロジコ"
              trim
              @blur="form.SKS_KAISYA = replaceChar(form.SKS_KAISYA)"
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>
          正式企業名（フリガナ）（請求先）
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="SKS_KAISYA_KANA"
            v-slot="{ errors }"
            rules="required|max:50|katakana"
          >
            <b-form-input
              v-model="form.SKS_KAISYA_KANA"
              ref="SKS_KAISYA_KANA"
              class="col-md-6"
              maxlength="50"
              :state="errors.length ? false : null"
              placeholder="カブシキガイシャロジコ"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr v-if="isLeaseFlg">
        <th>
          部署名（請求先）
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="SKS_BUSYO_MEI"
            v-slot="{ errors }"
            rules="required|max:30|char"
          >
            <b-form-input
              v-model="form.SKS_BUSYO_MEI"
              ref="SKS_BUSYO_MEI"
              class="col-md-6"
              maxlength="30"
              :state="errors.length ? false : null"
              placeholder="経理部"
              trim
              @blur="form.SKS_BUSYO_MEI = replaceChar(form.SKS_BUSYO_MEI)"
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>郵便番号（請求先）</th>
        <td>
          <div class="row">
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:3"
                name="SKS_YUBIN1"
              >
                <b-form-input
                  type="tel"
                  ref="SKS_YUBIN1"
                  maxlength="3"
                  v-model="form.SKS_YUBIN1"
                  :state="errors.length ? false : null"
                  placeholder="160"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <span class="py-2">-</span>
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:4"
                name="SKS_YUBIN2"
              >
                <b-form-input
                  type="tel"
                  ref="SKS_YUBIN2"
                  maxlength="4"
                  v-model="form.SKS_YUBIN2"
                  :state="errors.length ? false : null"
                  placeholder="0023"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <button
              type="button"
              class="btn btn-success bold"
              @click="searchAddress"
              :disabled="!isYubinSearch"
              style="height: 40px"
            >
              検索
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <th>
          都道府県・市区郡（請求先）
          <span class="must">必須</span>
        </th>
        <td>
          <div class="row">
            <div class="col-4 col-md-4 col-lg-3 pr-0">
              <validation-provider
                v-slot="{ errors }"
                name="SKS_TODO_CD"
                rules="required"
                ref="SKS_TODO_MEI"
              >
                <b-form-select
                  v-model="form.SKS_TODO_CD"
                  ref="SKS_TODO_CD"
                  :state="errors.length ? false : null"
                  :options="prefList"
                  trim
                  @change="changePref"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div class="col-7 col-md-5 col-lg-4">
              <validation-provider
                v-slot="{ errors }"
                name="SKS_SHIKU_CD"
                rules="required"
                ref="SKS_SHIKU_MEI"
              >
                <b-form-select
                  :disabled="!cityList.length"
                  ref="SKS_SHIKU_CD"
                  v-model="form.SKS_SHIKU_CD"
                  :state="errors.length ? false : null"
                  :options="cityList"
                  trim
                  @change="changeCity"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th>
          町名・番地（請求先）
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="SKS_BANCHI"
            v-slot="{ errors }"
            rules="required|max:25|char"
          >
            <b-form-input
              maxlength="25"
              ref="SKS_BANCHI"
              v-model="form.SKS_BANCHI"
              :state="errors.length ? false : null"
              placeholder="西新宿7－4－3 升本ビル4F"
              trim
              @blur="form.SKS_BANCHI = replaceChar(form.SKS_BANCHI)"
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>
          TEL（請求先）
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="SKS_TEL"
            v-slot="{ errors }"
            rules="required|tel"
          >
            <b-form-input
              class="col-md-6"
              ref="SKS_TEL"
              maxlength="17"
              v-model="form.SKS_TEL"
              :state="errors.length ? false : null"
              placeholder="03-5937-4777"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>FAX（請求先）</th>
        <td>
          <validation-provider name="SKS_FAX" v-slot="{ errors }" rules="fax">
            <b-form-input
              class="col-md-6"
              ref="SKS_FAX"
              maxlength="17"
              v-model="form.SKS_FAX"
              :state="errors.length ? false : null"
              placeholder="03-5937-6666"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr v-if="!isLeaseFlg">
        <th>
          ご担当者名（請求先）
          <span class="must">必須</span>
        </th>
        <td>
          <div class="row col-md-11">
            <div class="row col-md-6 pr-md-0">
              <div class="col-md-1">
                <label class="mt-2">姓</label>
              </div>
              <div class="col-md-10">
                <validation-provider
                  name="SKS_TANTO_MEI_SEI"
                  v-slot="{ errors }"
                  rules="required|max:20|char"
                >
                  <b-form-input
                    v-model="form.SKS_TANTO_MEI_SEI"
                    ref="SKS_TANTO_MEI_SEI"
                    maxlength="20"
                    :state="errors.length ? false : null"
                    placeholder="山田"
                    trim
                    @blur="
                      form.SKS_TANTO_MEI_SEI = replaceChar(
                        form.SKS_TANTO_MEI_SEI
                      )
                    "
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
            <div class="row col-md-6 pr-md-0">
              <div class="col-md-1">
                <label class="mt-2">名</label>
              </div>
              <div class="col-md-10">
                <validation-provider
                  name="SKS_TANTO_MEI"
                  v-slot="{ errors }"
                  rules="required|max:20|char"
                >
                  <b-form-input
                    v-model="form.SKS_TANTO_MEI"
                    ref="SKS_TANTO_MEI"
                    maxlength="20"
                    :state="errors.length ? false : null"
                    placeholder="太郎"
                    trim
                    @blur="form.SKS_TANTO_MEI = replaceChar(form.SKS_TANTO_MEI)"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr v-if="!isLeaseFlg">
        <th>
          ご担当者メールアドレス（請求先）
          <br v-if="isTablet" />
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="SKS_TANTO_MAIL_ADDR"
            v-slot="{ errors }"
            rules="required|max:50|email"
          >
            <b-form-input
              v-model="form.SKS_TANTO_MAIL_ADDR"
              ref="SKS_TANTO_MAIL_ADDR"
              class="col-md-8"
              maxlength="50"
              :state="errors.length ? false : null"
              placeholder="yamada@mail.co.jp"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
    </table>
  </section>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Constant from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'

export default {
  name: 'Seikyu',

  mixins: [Mixin],

  props: {
    /** リース会社フラグ */
    isLeaseFlg: {
      type: Boolean,
      default: false,
    },

    /** データ取得フラグ */
    isGetData: {
      type: Boolean,
      default: false,
    },

    /** オブザーバー */
    observer: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    /** 市区町村リスト */
    cityList: [],

    /** 入力データ */
    form: {
      SEIKYU_SAKI_KBN: false,
      SKS_KAISYA: null,
      SKS_KAISYA_KANA: null,
      SKS_BUSYO_MEI: null,
      SKS_YUBIN1: null,
      SKS_YUBIN2: null,
      SKS_TODO_CD: null,
      SKS_TODO_MEI: null,
      SKS_SHIKU_CD: '',
      SKS_SHIKU_MEI: null,
      SKS_BANCHI: null,
      SKS_TEL: null,
      SKS_FAX: null,
      SKS_TANTO_MEI_SEI: null,
      SKS_TANTO_MEI: null,
      SKS_TANTO_MAIL_ADDR: null,
    },
  }),

  methods: {
    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.SKS_TODO_CD
      this.form.SKS_TODO_MEI = null
      this.form.SKS_SHIKU_CD = ''
      this.form.SKS_SHIKU_MEI = null
      if (todoCd) {
        this.form.SKS_TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.SKS_SHIKU_CD
      this.form.SKS_SHIKU_MEI = null
      if (shikuCd) {
        this.form.SKS_SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.SKS_TODO_CD) return
      return Store.dispatch('address/getCityList', this.form.SKS_TODO_CD).then(
        () => {
          const cityList = _.cloneDeep(Store.state.address.cityList)
          cityList.unshift({
            value: '',
            text: '未選択',
          })
          this.cityList = cityList
        }
      )
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.SKS_YUBIN1}${this.form.SKS_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.SKS_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.SKS_TODO_MEI = this.getText(
            this.prefList,
            this.form.SKS_TODO_CD
          )
          this.form.SKS_SHIKU_MEI = item.address2
          this.form.SKS_BANCHI = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.SKS_SHIKU_MEI,
            'text'
          )
          if (city) this.form.SKS_SHIKU_CD = city.value
        }
      })
    },

    /** 表示された入力データのみ設定する */
    cleanup() {
      let d = _.cloneDeep(this.form)
      for (var name in d) {
        d[name] = this.$refs[name] ? d[name] : null
      }
      return d
    },
  },

  computed: {
    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.SKS_YUBIN1 &&
        this.form.SKS_YUBIN2 &&
        this.observer &&
        this.observer.fields.SKS_YUBIN1 &&
        this.observer.fields.SKS_YUBIN2 &&
        !this.observer.fields.SKS_YUBIN1.failed &&
        !this.observer.fields.SKS_YUBIN2.failed
      )
    },
  },

  watch: {
    /* データ取得イベント監視 */
    async isGetData(val) {
      if (val) this.$emit('setData', this.cleanup())
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
</style>



// WEBPACK FOOTER //
// src/components/apply/Seikyu.vue